// extracted by mini-css-extract-plugin
export default {"loading":"dashboard_loading__MzLIz","rotate":"dashboard_rotate__BwVjN"};